<template>
  <VueDragResize class="quiz" ref="container" :parentLimitation="false" :isResizable="false" :z="z" :x="left" :y="topRef" @dragging="dragging" @dragstop="dragstop" @clicked="updateZ" :style="{opacity:opacity}">
    <h3 class="box-title">
      <i class="fas fa-chevron-left" v-show="questions.length>1" @click="previousQuestion"></i> 
       {{title}} 
      <i class="fas fa-chevron-right" v-show="questions.length>1" @click="nextQuestion"></i>
    </h3>
    <a class="quiz-close-button" href="#" @click.prevent="hideQuiz()" @touchstart="hideQuiz()">X</a>
    <div v-show="!finished" class="interactivity-contents">
      <div class="question-container" v-show="showQuestion" ref="question">
        <div class="question">{{currentQuestion.question && currentQuestion.question.prompt ? currentQuestion.question.prompt : currentQuestion.question}}</div>                 
      </div>
      <div class="box-answers">
        <a class="answer" v-for="(answer, index) in currentQuestion.answers" :key="index" href="#" @click.prevent="setAnswer(index)" @touchstart="setAnswer(index)">{{ typeof answer === 'object' ? answer.text : answer  }}</a>
      </div>
    </div>
    <div v-if="showResultsConditionsMet" class="result" ref="result">
      <p class="score-text-title">{{currentQuestion.question && currentQuestion.question.prompt ? currentQuestion.question.prompt : currentQuestion.question}}</p>
      <p class="score-text">{{ `${resultsTitle}`}}</p>
      <p class="score-text" v-if="typeShowResults">Você acertou {{`${typeShowResults ? `${Math.abs(Math.round(score * 100).toFixed(0))}%`:''}`}}
      </p>
      <a href="#" class="close" @click.prevent="endQuiz">Fechar</a>
    </div> 
  </VueDragResize>
</template>
<script>
import VueDragResize from 'vue-drag-resize';
import api from '@/services/api';


export default {
  name: 'Quiz',
  components: {
    VueDragResize,
  },
  props: {
    currentQuiz: Object,
    title: String,
    resultsTitle: String,
    rawData: Object,
    isMobile: Boolean,
    isVideoFullscreen: Boolean,
    z: Number,
    topRef: Number,
    leftRef: Number,
  },
  data() {
    return {
      showQuestion: true,
      showResults: false,
      currentQuestion: {},
      currentQuestionIndex: 0,
      questions: [],
      answers: [],
      finished: false,
      score: -1,
      width: 0,
      height: 0,
      top: 200,
      left: 70,
      counter: 0,
      isDragging: false,
      quizOnStatusList: [],
    };
  },
  watch: {
    currentQuiz() {
      if (this.currentQuiz) this.beginQuiz(this.currentQuiz);
    },
  },
  methods: {
    retrieveScoreFromApiStatus() {
      return new Promise((resolve, reject) => {
        api
          .get(`event/${this.$store.state.eventId}/channels/${this.$route.params.stream}/status`)
          .then(response => {
            // console.log('retrieveScoreFromApiStatus', { response });
            this.quizOnStatusList = response.data.filter(item => item.reference_type === 'quiz');
            this.quizOnStatusList.forEach(item => {
              if (item.interactivity_id === this.currentQuiz.id) {
                this.score = parseFloat(item.interacted_scored)
              }
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async beginQuiz(quizData) {
      this.currentQuestionIndex = 0;
      this.questions = quizData.questions;
      this.answers = [];
      this.finished = false;
      this.score = -1;
      this.currentQuestion = this.questions[this.currentQuestionIndex];
      this.showResults = false;
      let marker = `${this.$store.state.user.id}-${quizData.id}`;
      if (this.$store.state.markers.answeredQuiz.includes(marker)) {
        this.showResults = this.typeShowResults;
        this.finished = true;
        // console.log('beginQuiz', { quiz });
        await this.retrieveScoreFromApiStatus();
      }
    },
    setAnswer(value) {
      if (this.isDragging) return;
      if (this.finished) return;

      if (!this.answers.length) this.answers = [[]];
      this.answers[this.currentQuestionIndex] = [value];

      const obj = {
        id: this.currentQuestion.id,
        answers: this.answers.map(a => JSON.stringify(a)),
      };
      // console.log('setAnswer', { obj });

      if (this.answers.length === this.questions.length) {
        // console.log('finished setAnswer', { obj });
        this.$emit('finished', obj);

        this.finished = true;
        this.showResults = this.typeShowResults;
      } else {
        this.currentQuestionIndex++;
        if (this.currentQuestionIndex >= this.questions.length - 1) this.currentQuestionIndex = this.questions.length - 1;
        this.currentQuestion = this.questions[this.currentQuestionIndex];
      }
    },
    setScore(value) {
      // console.log('setScore', value);
      this.score = value;
      setTimeout(() => {
        this.showResults = this.typeShowResults;
      }, 300);
    },
    endQuiz() {
      this.showResults = true;
      this.currentQuestionIndex = 0;
    },
    previousQuestion() {
      this.currentQuestionIndex--;
      if (this.currentQuestionIndex <= 0) this.currentQuestionIndex = 0;
      this.currentQuestion = this.questions[this.currentQuestionIndex];
    },
    nextQuestion() {
      this.currentQuestionIndex++;
      if (this.currentQuestionIndex >= this.questions.length - 1) this.currentQuestionIndex = this.questions.length - 1;
      this.currentQuestion = this.questions[this.currentQuestionIndex];
    },
    dragging(newRect) {
      this.isDragging = true;
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    dragstop() {
      this.isDragging = false;
    },
    updateZ() {
      this.counter++;
      if (this.counter > 1) {
        this.counter = 1;
        this.$emit('bringToFront', 'quiz');
      }
    },
    hideQuiz() {
      this.$emit('hideQuiz');
    },
  },
  computed: {
    computeScore() {
      if (this.currentQuiz.interacted_scored) {
        this.score = parseFloat(this.currentQuiz.interacted_scored.replace(',', '.'));
      }
    },
    showResultsConditionsMet() {
      return (this.finished && this.score >= 0) || (this.finished && this.currentQuiz && this.currentQuiz.interacted_scored);
    },
    typeShowResults() {
      if (this.currentQuiz?.type?.showResults) return this.currentQuiz.type.showResults;
      else return false;
    },
    topComputed() {
      return this.topRef;
    },
    leftComputed() {
      return this.leftRef + 10;
    },
    opacity() {
      return this.z == 2 ? 1 : 0.7;
    },
  },
  beforeMount() {
    this.top = this.topRef;
    this.left = this.leftRef;
    if (this.isMobile) {
      this.top = 200;
      this.left = 50;
    }
  },
};
</script>
<style lang="scss">
.close {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;

  &:hover {
    background-color: $link-highlight;
  }
}
.score-text {
  color: whitesmoke;
  font-size: 1rem;
  opacity: 0.7;
}
.score-text-title {
  text-align: left;
  margin: -10px 0 10px;
  font-size: 1rem;
  font-weight: bolder;
  color: whitesmoke;
  opacity: 0.7;
}
</style>